import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import Homepage from './Components/Homepage/Homepage';

function App() {
  return (
    <div className="App">
      <Homepage></Homepage>
    </div>
  );
}

export default App;
